import { IRoute } from '../interfaces/Route';
import NewsletterExtraction from 'pages/newsletter/NewsletterExtraction';

export const NEWSLETTER_ROUTES:IRoute[] = [
    {
        path: '/admin/newsletter/',
        component: NewsletterExtraction,
        codename:'newsletter',
        exact: true,
        requiredRoles: []
    }
]
